import React from 'react';
import {LoadingSpinner} from 'components';
import {SliceStatus} from 'interfaces';
import {useTranslation} from 'react-i18next';

interface SessionLoadersProps {
  billingSessionsStatus: SliceStatus;
  hasNextPage: boolean;
}

export function SessionLoaders({
  billingSessionsStatus,
  hasNextPage,
}: SessionLoadersProps) {
  const {t} = useTranslation();

  if (billingSessionsStatus === SliceStatus.pending) {
    return (
      <div className="w-full flex justify-center items-center mx-auto space-x-3 my-8">
        <LoadingSpinner width={20} height={20} type="Oval" />
        <h4 className="font-medium text-gray-600">
          {t(
            'transactionHistory.loadingMoreSessions',
            'Loading more sessions...',
          )}
        </h4>
      </div>
    );
  }

  if (billingSessionsStatus === SliceStatus.resolved && !hasNextPage) {
    return (
      <p className="text-center font-light py-3">
        {t('transactionHistory.youreAllCaughtUp', "You're all caught up!")}
        <span role="img" aria-label="celebration">
          🎊
        </span>
      </p>
    );
  }

  return null;
}
